import React, { Component } from "react";
import PdfRender from "../../layout/PdfRender";

import now_song_app from "../../../img/ppe/now_song_app.PNG";
import now_song_chat from "../../../img/ppe/now_song_chat.png";

// Load images for part 2 subject
import now_song_produits from "../../../img/ppe/now_song_produits.png";
import now_song_produit from "../../../img/ppe/now_song_produit.png";
import now_song_panier from "../../../img/ppe/now_song_panier.png";
import now_song_profil from "../../../img/ppe/now_song_profil.png";
import now_song_modifier_utilisateur from "../../../img/ppe/now_song_modifier_utilisateur.png";
import now_song_manage_utilisateur from "../../../img/ppe/now_song_manage_utilisateur.png";
import now_song_manage_produit from "../../../img/ppe/now_song_manage_produit.png";
import now_song_manage_historique_commande from "../../../img/ppe/now_song_manage_historique_commande.png";
import now_song_admin from "../../../img/ppe/now_song_admin.png";

let imagesPPE1 = [
	now_song_produits,
	now_song_produit,
	now_song_panier,
	now_song_profil,
	now_song_modifier_utilisateur,
	now_song_manage_utilisateur,
	now_song_manage_produit,
	now_song_manage_historique_commande,
	now_song_admin,
];

export default class PPE1 extends Component {
	render() {
		return (
			<>
				<div className="container">
					<div className="row mt-5">
						<div className="col-lg-12">
							<div className="section-title">
								<h2>Information</h2>
								<p>
									<b>❯ Project(s) : </b> Projet Personnel Encadré 1<br/>
									<b>❯ Technologie(s) : </b> Php, Linux, SQL, Javascript, Composer<br/>
									<b>❯ Base de données : </b> MySQL<br/>
									<b>❯ Spécialités : </b> SLAM, SISR<br/>
									<b>❯ Date : </b> 2018<br/>
								</p>
							</div>
						</div>
					</div>

					<div className="row mt-3">
						<div className="col-lg-12">
							<h3 className="text-heading">SISR (Solutions d’infrastructure, systèmes et réseaux), 2 Phases</h3>

							<h4 className="mb-20">Phase 1 : Configuration d’un poste client pour les commerciaux (partie oral)</h4>

							<div className="row">
								<div className="col-lg-12">
									<div className="wrapper-pdf">
										<PdfRender file="./../storage/PPE_1_-_Phase_1,_Optimisation_de_l'installation_des_logiciels_du_poste_de_M.Leo,_A.Karim,_M.Theo.pdf" />
									</div>

									<div className="text-center mt-30">
										<h4>
											Optimisation de l'installation des logiciels du poste <br/>
											<small className="text-muted">de M.Leo, A.Karim, M.Theo</small>
										</h4>
										<p>
											On a fait une démonstration des solutions devant le client (le professeur de réseau).
										</p>
									</div>
								</div>
							</div>

							<h4 className="mb-20">Phase 2 : Mise au point d’un serveur web</h4>

							<div className="row">
								<div className="col-md-6">
									<PdfRender file="./../storage/Tuto_Installation_et_configuration_d'un_server_(web,_ftp,_dns)_de_M.Leo,_A.Karim,_M.Theo.pdf" />
								</div>
								<div className="offset-md-1 col-md-5 mt-sm-3">
									<div className="portfolio_right_text mt-30">
										<h4>
											Tuto Installation et configuration d'un server (web, ftp, dns) <br/>
											<small className="text-muted">de M.Leo, A.Karim, M.Theo</small>
										</h4>
										<p>
											Un tutoriel de configuration et d'installation des trois services suivants : Web (Apache2), FTP (ProFTPd), DNS (Bind9) a été fourni au professeur de réseau (voir le document ci-contre).
										</p>
									</div>
								</div>
							</div>

						</div>
					</div>

					<div className="row mt-3" id="PPE1SLAM">
						<div className="col-lg-12">
							<h3 className="text-heading">SLAM (Solutions Logicielles et Applications Métier)</h3>

							<h4 className="mb-20">Project Now Song</h4>

							<div className="row my-5">
								<div className="col-lg-12">
									<div className="wrapper-pdf">
										<PdfRender file="./../storage/Presentation_PPE_1_-_de_M.Leo,_A.Karim,_M.Theo.pdf" />
									</div>

									<div className="text-center mt-30">
										<h4>
											Presentation du Projet Personnel Encadré 1 <br/>
											<small className="text-muted">de M.Leo, A.Karim, M.Theo</small>
										</h4>
										<p>
											Ceci est le premier document Power Point utiliser pour présenter le site web Now Song.
										</p>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-md-4">
									<a href={now_song_app} className="img-gal">
										<img src={now_song_app} alt="" className="img-fluid" />
									</a>
									{imagesPPE1.map(i => <a href={i} className="img-gal"> </a>)}
								</div>
								<div className="col-md-8 mt-sm-20 text-left">
									<h5>Now song, produits, ...</h5><br/>

									<p>
										<a href="https://nowsong.ascencia.re/" target="_blank" rel="noopener noreferrer">Now Song</a>  est application web e-commerce développer entièrement en php (coté backend) en pendant le PPE 1 (2018-2019).

										Il est capabale de gérer un enssemble de produit audio proposer aux clients.
										Le panier client est fonctionnelle, même lors que l'on ferme le navigateur ou que l'on quitte la session, en ce reconnectant au compte vous aurait un panier inpact. <br/>

										Les produits dans le panier sont gérables. <br/>

										Il est possible de payer la commande en passant par paypal, le système de paypal est directement intéger sur le site web. <span className="text-muted">(Attention
										seullement en sandbox puisque c'est un projet de cours...)</span> <br/>
									</p>

									<h5>Profil client</h5><br/>

									<p>
										Now song possède une interface profil client qui offre la possibilité de pouvoir visioner, modifier ou supprimer ces informations personnelles. (historiques de commandes, ...)
										On peut même imprimer les factures de commandes.
									</p>

									<h5>Administration, Statistiques</h5><br/>

									<p>
										Now song detient une interface d'administration, qui permet de gerer plus nois toute les fonctionnalités du site. <br/>

										Il est capable de manager les utilisateurs (changer les roles des utilisateurs, changer les informations des utilisateurs si cela est nécessaire),
										lister les commandes effectuer sur le site web (et même sortir en PDF les factures des commandes). <br/>

										Une page de l'administration présente des statistiques relatives activilités du site web, <u>par exemple :</u> les statistiques des produits acheters sur le site.
									</p>

									<h5>Versonning du projet</h5><br/>

									<p>
										Moi et mes camarades de classe nou avions directement pour du versionning avec git, nous avons utiliser comme plaforme d'herbergement de notre code <a href="https://gitlab.com/">Gitlab</a>.
									</p>

								</div>
							</div>

							<h4 className="mb-20">Project Now Song (Chat)</h4>

							<div className="row my-5">
								<div className="col-md-4">
									<a href={now_song_chat} className="img-gal">
										<img src={now_song_chat} alt="" className="img-fluid" />
									</a>
								</div>
								<div className="col-md-8 mt-sm-20 text-left">
									<p>
										Moi et mes camarades de classe, on a développé un chat communautaire qui est compatible avec les comptes clients de Now song. <br/>

										Sur le chat, on peut changer sont status, voir les autres utilisateurs connecter, poster des messages, un topic peut être defini sur le chat, et tous ça sans recharger la page.
									</p>
								</div>
							</div>

						</div>
					</div>
				</div>

			</>
		);
	}
}